import { useBaseViewModel } from '@/common';
import { CourseLineEntity } from '@/domains/course-lines/entities';
import { FindCourseLineUsecase } from '@/domains/course-lines/usecases';
import { useState } from 'react';
import { CourseLineHttpRepository } from '../adapters/repositories';

export default function GetDetailCourseLine() {
  const findCourseLineUC = new FindCourseLineUsecase(new CourseLineHttpRepository());
  const { loading, error, catchAction } = useBaseViewModel();
  const [courseLineData, setCourseLineData] = useState<CourseLineEntity>();

  const actionGetDetailCourseLine = async (id: string) => {
    await catchAction(async () => {
      const data = await findCourseLineUC.run(id);
      setCourseLineData(data);
    });
  };

  return {
    loading,
    error,
    courseLineData,
    actionGetDetailCourseLine,
  };
}
